module.exports = __webpack_public_path__ + "static/media/logo-p.e319e68a.svg";